var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applyButtonLayout",on:{"contextmenu":function($event){return _vm.$emit('contextmenu', $event)}}},[_c('button',{on:{"click":function($event){return _vm.$router.push({ name: 'page/applicant/main' })}}},[_vm._v("지원하기")])])}
var staticRenderFns = []

export { render, staticRenderFns }